import { render, staticRenderFns } from "./pdfLoader.vue?vue&type=template&id=0f61be2e&scoped=true&"
import script from "./pdfLoader.vue?vue&type=script&lang=js&"
export * from "./pdfLoader.vue?vue&type=script&lang=js&"
import style0 from "./pdfLoader.vue?vue&type=style&index=0&id=0f61be2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f61be2e",
  null
  
)

export default component.exports